import { Box, type BoxProps } from "@chakra-ui/layout";
import { motion } from "framer-motion";

export const Animation = motion<BoxProps>(Box);
